import React from "react";
import { Archive } from "lucide-react";

/**
 * Phase 11 D — Reusable "Show archived (last 30 days)" filter toggle.
 * Rendered above list views. On flip, the caller re-fetches with
 * ?include_deleted=true|false.
 */
export default function ArchivedFilterToggle({ value, onChange, testid = "archived-toggle" }) {
    return (
        <button
            type="button"
            onClick={() => onChange(!value)}
            className={`inline-flex items-center gap-1.5 rounded-full border px-3 py-1.5 text-xs font-medium transition ${
                value
                    ? "border-mm-navy bg-mm-navy text-white"
                    : "border-mm-line bg-white text-mm-muted hover:border-mm-navy/40 hover:text-mm-ink"
            }`}
            data-testid={testid}
            aria-pressed={value}
        >
            <Archive size={12} />
            {value ? "Showing archived" : "Show archived (30d)"}
        </button>
    );
}

/** Small "Archived · deletes in Xd" pill for rows currently soft-deleted. */
export function ArchivedRowBadge({ deletedAt, testid = "archived-row-badge" }) {
    if (!deletedAt) return null;
    const then = new Date(deletedAt).getTime();
    if (Number.isNaN(then)) return null;
    const daysLeft = Math.max(0, 30 - Math.floor((Date.now() - then) / 86_400_000));
    return (
        <span
            className="inline-flex items-center gap-1 rounded-full border border-mm-line bg-mm-bg px-2 py-0.5 text-[10px] font-medium uppercase tracking-wider text-mm-muted"
            data-testid={testid}
        >
            <Archive size={9} />
            Archived · deletes in {daysLeft}d
        </span>
    );
}
